const Localisation = (function () {

    const _log = console.log;
    const _warn = console.warn;
    const _error = console.error;

    const languageList = [
        { tag: 'en', language: 'English' },
        { tag: 'es', language: 'Spanish' },
        { tag: 'es-419', language: 'Spanish Latin America' },
        { tag: 'es-mx', language: 'Spanish Mexican' },
        { tag: 'it', language: 'Italian' },
        { tag: 'fr', language: 'French' },
        { tag: 'de', language: 'German' },
        { tag: 'pt', language: 'Portuguese' },
        { tag: 'pt-br', language: 'Portuguese Brazilian' },
        { tag: 'zh-cn', language: 'Chinese Simplified' },
        { tag: 'zh-tw', language: 'Chinese Traditional (Mandarin)' },
        { tag: 'zh-hk', language: 'Chinese Traditional (Cantonese)' },
        { tag: 'ja', language: 'Japanese' },
        { tag: 'ko', language: 'Korean' },
        { tag: 'th', language: 'Thai' },
        { tag: 'sv', language: 'Swedish' },
        { tag: 'da', language: 'Danish' },
        { tag: 'no', language: 'Norwegian' },
    ]

    let translations = {};

    let userLanguage = 'en';

    let win, html;

    function init () {
        win = $(window);
        html = $('html');

        return Promise.all([
            $.getJSON('/data/keywords.json'),
            $.getJSON('/data/destinations.json'),
            $.getJSON('/data/interests.json'),
            $.getJSON('/data/ogb-keyword-whitelist.json'),
        ])
            .then(makeTranslationsMap)
            .then(detectLanguage)
            .then(() => {
                doLanguageRedirect();
                registerEvents();
            })
            .catch(e => _error(e))
    }


    function makeTranslationsMap (res) {
        translations.ogb = res[3];
        translations.keywords = lowerCaseLanguageKeys(res[0]).reduce((acc, row) => {
            row.key = row.en;
            let ogbEn = translations.ogb.filter(ogbRow => {
                return ogbRow['Selected UNMODIFIED words'].toLowerCase() === row.key.toLowerCase();
            });
            row.en = ogbEn.length ? ogbEn[0]['Spellchecked (or otherwise modified)'] : row.en;
            acc = acc.concat([row]);
            return acc;
        }, []);
        translations.destinations = lowerCaseLanguageKeys(res[1]);
        translations.interests = lowerCaseLanguageKeys(res[2]);
    }


    function doLanguageRedirect () {
        if (window.location.pathname === '/' && userLanguage === 'en') return;
        if (window.location.pathname === `/${userLanguage}/`) return;
        window.location.replace(userLanguage === 'en' ? '/' : `/${userLanguage}/`);
    }


    /*
    https://stackoverflow.com/questions/1043339/javascript-for-detecting-browser-language-preference
    https://github.com/dansingerman/jQuery-Browser-Language
    */
    function detectLanguage () {
        return $.ajax({
            url: '//ajaxhttpheaders.appspot.com',
            dataType: 'jsonp',
        }).then(headers => {
            const supportedLanguages = languageList.map(item => item.tag);
            const supportedLanguage = AcceptLanguageParser.pick(supportedLanguages, headers['Accept-Language']);
            if (supportedLanguage) userLanguage = supportedLanguage;
        }).catch(e => _error(e));
    }


    function translateKeywords (names) {
        return names.map((nameObj) => {
            return {
                name: getKeywordTranslation(nameObj.name) || nameObj.name,
                key: nameObj.key,
                handle: nameObj.name,
            };
        });
    }


    function translateTaxonomies (names) {
        return names.map((nameObj) => {
            return {
                name: getTaxonomyTranslation(nameObj.name) || nameObj.name,
                type: nameObj.type,
                key: nameObj.name,
            };
        });
    }


    /*
    Input is:
    [ {en:'', FR:'', zh-CN:'', …} ]

    Output is:
    [ {en:'', fr:'', zh-cn:'', …} ]
    */
    function lowerCaseLanguageKeys (list) {
        return list.map(row => {
            const keys = Object.keys(row);
            return keys.reduce((acc, key) => {
                acc[key.toLowerCase()] = row[key];
                return acc;
            }, {});
        })
    }


    function getTaxonomyTranslation (word) {
        const taxonomyTranslations = translations.destinations.concat(translations.interests);
        const matches = taxonomyTranslations.filter(row => {
            if (row.en) return row.en.toLowerCase() === word.toLowerCase();
        });
        if (matches.length && matches[0][userLanguage]) {
            return matches[0][userLanguage];
        }
        if (!matches.length || matches.length > 1) {
            _warn(`Missing or multiple '${userLanguage}' translation for "${word}"`);
        }
        return null;
    }


    function getKeywordTranslation (word) {
        const matches = translations.keywords.filter(row => {
            if (row.key) return row.key.toLowerCase() === word.toLowerCase();
        });
        if (matches.length && matches[0][userLanguage]) {
            return matches[0][userLanguage];
        }
        if (!matches.length || matches.length > 1) {
            _warn(`Missing or multiple '${userLanguage}' translation for "${word}"`);
        }
        return null;
    }


    function registerEvents () {
    }


    return { init, translateKeywords, translateTaxonomies, getTaxonomyTranslation }
})()

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined')
    module.exports = Localisation;
else
    window.Localisation = Localisation;
